import apiService from "./api";
import { sanitizeQueryParams } from "@src/utility/helpers/apiHelper";
import type { SortOrderValue } from "@src/shared/constants/sort-order.constants";

export type ApiDynamicFormStatus = "active" | "inactive" | "draft";

export interface GetDynamicFormParams {
  page?: number;
  pageSize?: number;
  search?: string;
  status?: ApiDynamicFormStatus | string;
  isTemplate?: boolean | string;
  orderBy?: string;
  orderDirection?: SortOrderValue | Lowercase<SortOrderValue>;
  [key: string]: unknown;
}

export interface CreateDynamicFormPayload {
  key: string;
  name: string;
  description?: string | null;
  schema: any;
  route: string;
  isTemplate?: boolean;
  status?: ApiDynamicFormStatus;
}

export type UpdateDynamicFormPayload = Partial<CreateDynamicFormPayload>;

export class DynamicFormService {
  async getDynamicForms(query: GetDynamicFormParams) {
    return apiService.get("/dynamic-forms", {
      params: sanitizeQueryParams(query),
    });
  }

  async getDynamicForm(id: string | number) {
    return apiService.get(`/dynamic-forms/${id}`);
  }

  async createDynamicForm(data: CreateDynamicFormPayload) {
    return apiService.post("/dynamic-forms", data);
  }

  async updateDynamicForm(id: string | number, data: UpdateDynamicFormPayload) {
    return apiService.put(`/dynamic-forms/${id}`, data);
  }

  async deleteDynamicForm(id: string | number) {
    return apiService.delete(`/dynamic-forms/${id}`);
  }

  async getDynamicFormTemplates() {
    return apiService.get("/dynamic-forms/templates");
  }
}

export const dynamicFormService = new DynamicFormService();
